var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgHome = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_66PQnQ",
    "data-name": "66PQnQ"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21.57,11.66v8.3c0,1.37-1.15,2.42-2.48,2.42H4.84c-1.3-.01-2.4-1.13-2.4-2.41v-8.28s1.39-1.05,1.39-1.05v9.15c0,.62.44,1.2,1.1,1.2h14.05c.72,0,1.2-.5,1.2-1.2v-9.16s1.38,1.04,1.38,1.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.49,6.67l4.37,3.4c.23.18.13.67,0,.84-.16.22-.58.43-.88.2L12.93,3.3c-.53-.41-1.32-.41-1.85,0L1.18,11.01c-.36.28-.8.25-1.05-.08s-.14-.75.21-1.03L10.32,2.17c.94-.73,2.31-.72,3.25-.08,1.05.71,1.94,1.47,3,2.29v-.97c.02-.24.28-.57.54-.57h1.75c.31,0,.62.25.62.59v3.24Z"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgHome);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/home.1ada2082ebead0b32cedb80dc52c28e6.svg";